import {Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spl-viewer',
  templateUrl: './spl-viewer.component.html',
  styleUrls: ['./spl-viewer.component.scss'],
})
export class SplViewerComponent implements OnInit {

  constructor() {
  }

  // placeholder
  ngOnInit() {
    this.initTabIndex();
  }

  initTabIndex() {
    (document.activeElement as HTMLElement).blur();

    const main = document.getElementById("firstDiv");

    if (main) {
      main.focus();
    }
  }
}
